export const AUTH_RETURN_TO_KEY = "bloodline.auth.return_to";
export const LAST_AUTH_CLIENT_KEY = "bloodline.auth.lastClientId";

export const isSafeInternalReturnUrl = (value: string | null): value is string =>
  value !== null && value.startsWith("/") && !value.startsWith("//") && !value.startsWith("/auth/callback");

export const storeAuthReturnTo = (value: string): void => {
  if (isSafeInternalReturnUrl(value)) {
    sessionStorage.setItem(AUTH_RETURN_TO_KEY, value);
  }
};

export const consumeAuthReturnTo = (): string | null => {
  const value = sessionStorage.getItem(AUTH_RETURN_TO_KEY);
  sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
  return isSafeInternalReturnUrl(value) ? value : null;
};
